import { useEffect } from "react";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { CURRENCIES } from "./lib/constants";
import { LanguageToggle } from "./LanguageToggle";
import { DropDown } from "@components/DropDown";
import { useCurrencyDispatch, useCurrencyState } from "@hooks/index";
import { useModal } from "@components/ModalV2";
import styles from "./announcementBar.module.css";
import { SetRegionModal } from "./SetRegionModal";
import { setStorefront } from "@hooks/index";


export function AnnouncementBarLeft() {
  const router = useRouter();
  const dispatch = useCurrencyDispatch();
  const { currency } = useCurrencyState();
  const { isShown, toggle } = useModal();
  const locationCookie = Cookies.get("location");

  const { pathname, asPath, query, locale } = router;

  useEffect(() => {
    // Set currency to GBP if locale is 'gb'
    if (locale === 'gb') {
      dispatch({ type: "set", currency: 'GBP' });
      Cookies.set("cart_currency", 'GBP');
      setStorefront('kotn-uk');
    } else {
      setStorefront('kotn-ss15');
    }
  }, []);

  useEffect(() => {
    const location = locationCookie && JSON.parse(locationCookie);
    // const isQuebec = location?.country === "CA" && location?.region === "QC";
    // if (location) setIsQuebec(isQuebec);
    if (location?.country === "GB") {
      if (locale !== 'gb') {
        toggle(true);
      }
    }
  }, [locationCookie]);

  const handleSelectedItemChange = ({ selectedItem }) => {
    dispatch({ type: "set", currency: selectedItem });
    Cookies.set("cart_currency", selectedItem);

    if (selectedItem === 'GBP' && locale !== 'gb') {
      toggle(true);
    } else {
      setStorefront('kotn-ss15');
      router.push({ pathname, query }, asPath, { locale: '' });
    }
  };

  return (
    <div className={styles.announcementLeft}>
      <SetRegionModal isShown={isShown} setToggle={toggle}/>

      {currency && (
        <DropDown
          items={CURRENCIES}
          selectedItem={currency}
          handleSelectedItemChange={handleSelectedItemChange}
        />
      )}
      <LanguageToggle />
    </div>
  );
}
